import React, {useState} from 'react';
import LinkIcon from "../../../../ui/svg/common/link";
import DragAndDropIcon from "../../../../ui/svg/common/drag-and-drop";
import {copyPresetLink} from "../services/logic-helper";
import {useAppSelector} from "../../creator-presets/DAL/store";
import InfoIcon from "../../../../ui/svg/common/info";
import {isMobile, isTablet} from "../../../../domain/common";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";
import AudioBase64 from "../../../galleries/audio-base64/audio-base64";
import {AudioBase64StyleEnum} from "../../../galleries/audio-base64/interfaces";

const HearOnYourTrack = () => {
    const [showLinkWasCopied,setShowLinkWasCopied] = useState(false);
    const [showLinkBubble, setShowLinkBubble] = useState(false);
    const [showDragAndDropBubble, setShowDragAndDropBubble] = useState(false);
    const isMobileScreen = isMobile() || isTablet();

    const mainPreset = useAppSelector((store) => store.mainPreset);
    const chainFullLink = 'https://'+window.location.host + '/studioverse/chain/' + mainPreset.presetGUID;
    const dragAndDropClasses = `hidden xl:flex lg:items-center w-btn inline-block font-normal border-gray-700 border w-auto px-4 mr-4 ${showDragAndDropBubble ? "bg-gray-600 text-white chain-page-dragdrop-gradient" : "bg-white text-gray-700"}`;
    const copyLinkClasses = `w-btn inline-block font-normal border-gray-700 border w-auto px-4 flex items-center ${ showLinkBubble ? "bg-gray-600 text-white chain-page-copy-gradient" : "bg-white text-gray-700"}`;

    const mouseOverLink = (evnt:any) => {
        // No Over event on mobile & tablet
        if(!isMobileScreen){
            setShowLinkBubble(true);
            setShowDragAndDropBubble(false);
        }

    }
    const mouseOutLink = (evnt:any) => {

        setShowLinkBubble(false);

    }
    const dragLink = (evnt:any) => {
        evnt.dataTransfer?.setData("text/plain", chainFullLink);
        evnt.dataTransfer.setData("text/uri-list", chainFullLink);
    }
    const mouseOverDragAndDrop = (evnt:any) => {

        setShowLinkBubble(false);
        setShowDragAndDropBubble(true);

    }
    const mouseOutDragAndDrop = (evnt:any) => {

        setShowDragAndDropBubble(false);

    }
    const mouseOut = (evnt:any) => {
        mouseOutDragAndDrop(evnt);
        mouseOutLink(evnt);
    }

    console.log('mainPreset.algType', mainPreset.algType)
    return (
        <div className="w-full mt-2 relative" onMouseLeave={mouseOut}>
            {
                mainPreset.audioDemo &&
                <div className="pb-6">
                    <AudioBase64 elId={mainPreset.presetGUID} presetGuid={mainPreset.presetGUID} buttonStyle={AudioBase64StyleEnum.ChainStyle}></AudioBase64>
                    <audio id={"pb64_" + mainPreset.presetGUID}/>
                </div>
            }

            <div className="waves-p pb-2 font-medium">Hear this chain on your track now</div>
            <div className="flex items-center mt-2">
                <div className="relative" onMouseEnter={mouseOverDragAndDrop}>
                    <div className="speech-bubble-right-container" style={{bottom: "70px", left: "0px"}}>
                        {showDragAndDropBubble &&
                            <div className="speech-bubble-right bg-white p-3 rounded shadow-md shadow-gray-500/50">

                                {
                                    mainPreset.algType === 'WSCR' &&
                                    <div className="w-full">Drag & drop this button directly into StudioVerse Audio Effects.</div>
                                }

                                {
                                    mainPreset.algType === 'WSCI' &&
                                    <div className="w-full">Drag & drop this button directly into StudioVerse Instruments.</div>
                                }
                            </div>
                        }
                    </div>

                    <button  className={dragAndDropClasses} draggable="true" onDragStart={dragLink}
                         aria-label="Drag And Drop link"
                         style={{borderRadius: "16px", height: "50px"}}
                         onClick={(evt) => {
                             sendGAEvent('Click', "drag & drop");
                         }}
                    >
                        <span>Drag & drop</span>
                        <div className="pl-3">
                            <DragAndDropIcon width={"30px"} color={showDragAndDropBubble ? "white" : "black"}/>
                        </div>
                    </button>
                </div>

                <div className="relative" onMouseEnter={mouseOverLink}>
                    <div className="speech-bubble-right-container" style={{bottom: "70px", left: "0px"}}>
                        {showLinkBubble &&
                            <div
                                className={`speech-bubble-right bg-white p-3 pr-2 rounded shadow-md shadow-gray-500/50`}>
                                <div className="w-full">Copy & Paste this link in your StudioVerse plugin search bar.</div>
                            </div>
                        }
                    </div>

                    <button className={copyLinkClasses} aria-label="Copy link"
                         onClick={() => {
                             sendGAEvent('Click', "copy link");
                             copyPresetLink(mainPreset.presetGUID, setShowLinkWasCopied);
                         }}
                         style={{borderRadius: "16px", height: "50px"}}>
                        <span>Copy</span>
                        <div className="pl-3">
                            <LinkIcon width={"26px"} color={showLinkBubble ? "white" : "black"}/>
                        </div>
                    </button>
                </div>

            </div>
            {
                showLinkWasCopied &&
                <div className="ok-box text-sm absolute w-full lg:w-1/2 bottom-full" aria-label="The link was copied to
                    clipboard">The link was copied to
                    clipboard</div>
            }

            <div className="w-full text-sm mt-8 md:w-3/4 bg-gray-100 rounded p-5 md:p-4">
                <div className="flex items-center justify-center">
                    <div className="pr-5 md:pr-4">
                        <InfoIcon width="22px" color={"#3452ff"}/>
                    </div>

                    {
                        mainPreset.algType === 'WSCR' &&
                        <div>
                            Hear chains on your tracks when you <span className="font-bold">drag & drop</span> or <span className="font-bold">copy & paste</span> chain links from the web directly into StudioVerse Audio Effects, inside your DAW of choice.
                        </div>
                    }

                    {
                        mainPreset.algType === 'WSCI' &&
                        <div>
                            Hear instrument chains when you <span className="font-bold">drag & drop</span> or <span className="font-bold">copy & paste</span> chain links from the web directly into StudioVerse Instruments, inside your DAW of choice.
                        </div>
                    }

                </div>

            </div>

        </div>
    )
};

export default HearOnYourTrack;